import CssBaseline from '@mui/material/CssBaseline';
import 'moment/locale/pt-br';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './assets/fonts/Poppins/Poppins-Regular.ttf';
import { type ConsentValue, getStoredConsent, onConsentChange } from './analytics/consent';
import { disableAnalytics, enableAnalytics, initPosthog } from './analytics/posthog';
import { ToastContainer } from './components';
import AppErrorBoundary from './components/AppErrorBoundary';
import CookieConsent from './components/CookieConsent';
import ThemeModeToggle from './components/ThemeModeToggle';
import { useDocumentTitle } from './hooks/useDocumentTitle';
import Routes from './routes';
import TagManager from './services/gtm';
import Theme from './styles/theme';

function App() {
  useDocumentTitle();

  useEffect(() => {
    // Camada essencial (erros, cookieless): carrega o PostHog logo no início para o
    // `capture_exceptions` pegar os erros não tratados.
    initPosthog();
    // Camada de analytics + session replay: depende do consentimento (LGPD).
    const applyConsent = (value: ConsentValue) => {
      if (value === 'accepted') enableAnalytics();
      else disableAnalytics();
    };
    const current = getStoredConsent();
    if (current) applyConsent(current);
    return onConsentChange(applyConsent);
  }, []);

  // Efeito, não corpo do render: aqui isto corria a cada re-render do App
  // (o `useDocumentTitle` provoca um por navegação) e a segunda chamada
  // rebentava a serializar um `dataLayer` já circular, deixando a app em branco.
  useEffect(() => {
    new TagManager().initialize('GTM-TCR3HLV');
  }, []);

  return (
    <BrowserRouter>
      <Theme>
        <CssBaseline />
        <AppErrorBoundary>
          <Routes />
        </AppErrorBoundary>
        <ThemeModeToggle />
        <ToastContainer autoClose={5000} position="bottom-center" />
        <CookieConsent />
      </Theme>
    </BrowserRouter>
  );
}
export default App;
